import { render, staticRenderFns } from "./ClickTask.vue?vue&type=template&id=674ba0c8&scoped=true&"
import script from "./ClickTask.vue?vue&type=script&lang=js&"
export * from "./ClickTask.vue?vue&type=script&lang=js&"
import style0 from "./ClickTask.vue?vue&type=style&index=0&id=674ba0c8&lang=scss&scoped=true&"
import style1 from "./ClickTask.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ba0c8",
  null
  
)

export default component.exports